import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Breakpoint } from './Breakpoint.js';
import { MountHandle } from '@sketch/utils';

function withBreakpoint(on, propName) {
    return Component => 
    // eslint-disable-next-line react/display-name
    (props) => {
        const [isEnabled, setIsEanabled] = useState(false);
        return (jsxs(Fragment, { children: [jsx(Breakpoint, Object.assign({ on: on }, { children: jsx(MountHandle, { onMount: () => setIsEanabled(true), onUnmount: () => setIsEanabled(false) }) })), jsx(Component, Object.assign({}, props, { [propName]: isEnabled }))] }));
    };
}

export { withBreakpoint };
